import { EmployeeType } from '../../types';

export type LegendType = EmployeeType | 'total';

interface LegendList {
  id: string;
  type: LegendType;
}

export const LEGEND_LIST: LegendList[] = [
  {
    id: '전체인원',
    type: 'total',
  },
  {
    id: '입사자',
    type: 'hired',
  },
  {
    id: '퇴사자',
    type: 'left',
  },
];
